import styled from 'styled-components';

import { gridSizes, weights } from 'utils/style';

import DateField from 'components/orders/Filters/Filters/Dates/DateField/container';

export default styled(DateField)`
  align-items: baseline;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: -1px 0;
  position: relative;

  button {
    font-size: ${gridSizes('M')};
    font-weight: ${weights('regular')};
    color: var(--grey700);

    &:hover {
      text-decoration: none;
    }

    svg {
      margin: 0;
    }
  }
`;
